module.exports = __webpack_public_path__ + "static/media/cargas-verde.8dd841ef.svg";